import moment from 'moment';
import { parse } from 'query-string';
import * as Sentry from '@sentry/react';
import { flutterNativeCall } from './flutterNative';
declare let operatorapp: any;
declare global {
  interface Date {
    getMonthText(): string;
    getWeekday(): string;
  }
}

export const setToken = (token: string) => localStorage.setItem('accessToken', token);
export const setLocale = (locale: string) => localStorage.setItem('locale', locale);

export const getQueryParams = () => {
  return decodeURI(window.location.search)
    .replace('?', '')
    .split('&')
    .map((param) => param.split('='))
    .reduce((values: any, [key, value]) => {
      values[key] = value;
      return values;
    }, {});
};

// Common function to clean action and btnType parameters from URL when routing to-from different pages
const cleanActionAndBtnTypeFromUrl = () => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.delete('action');
  currentUrl.searchParams.delete('btnType');
  window.history.replaceState({}, '', currentUrl.toString());
};

export const redirectToChatPage = (ticketId: string, vNum: string, lane: string) => {
  cleanActionAndBtnTypeFromUrl();
  window.location.href =
    window.location.origin + `/app/caraxes/marketplace/tickets/chat?ticketId=${ticketId}&vNum=${vNum}&lane=${lane}`;
};

export const redirectToChatPageThroughTripId = (tripId: string, q: string, ref: string, vNum: string, lane: string) => {
  cleanActionAndBtnTypeFromUrl();
  window.location.href =
    window.location.origin +
    `/app/caraxes/marketplace/tickets/chat?tripId=${tripId}&q=${q}&ref=${ref}&vNum=${vNum}&lane=${lane}`;
};

export const redirectToChatPageWithRef = (q: string, ref: string, vNum: string, lane: string) => {
  cleanActionAndBtnTypeFromUrl();
  window.location.href =
    window.location.origin + `/app/caraxes/marketplace/tickets/chat?q=${q}&ref=${ref}&vNum=${vNum}&lane=${lane}`;
};

export const redirectToNewDriverUpdateFlow = (lane: string[], vNum: string, tripId: string) => {
  cleanActionAndBtnTypeFromUrl();
  window.location.href =
    window.location.origin +
    `/app/caraxes/marketplace/driver-details-update?origin=${lane?.[0]}&destination=${lane?.[1]}&vehicleNum=${vNum}&tripId=${tripId}`;
};

export const redirectToDamagePolicy = () => {
  cleanActionAndBtnTypeFromUrl();
  window.location.href = window.location.origin + `/app/caraxes/public/policies/fo/damage-shortage-policy`;
};

export function setCookie(cname: string, cvalue: string, exhrs: number) {
  var d = new Date();
  d.setTime(d.getTime() + exhrs * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

export function getCookie(cname: string) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      if (c.substring(name.length, c.length) === 'undefined') {
        return '';
      }
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

// TODO: handle dependencies history, userSelectedDemandId
// eslint-disable-next-line no-extend-native
Date.prototype.getMonthText = function () {
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[this.getMonth()];
};

// TODO: handle dependencies history, userSelectedDemandId
// eslint-disable-next-line no-extend-native
Date.prototype.getWeekday = function () {
  var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[this.getDay()];
};

function secondsToDateTime(milliseconds: number) {
  var dateTime: any = {};
  var t: any = new Date(milliseconds);
  dateTime.date = t.getDate();
  dateTime.month = t.getMonth() + 1;
  dateTime.year = t.getFullYear();
  dateTime.monthText = t.getMonthText();
  dateTime.weekday = t.getWeekday();
  if (t.getHours() < 10) {
    dateTime.hour = '0' + t.getHours();
  } else {
    dateTime.hour = t.getHours();
  }
  if (t.getMinutes() < 10) {
    dateTime.minute = '0' + t.getMinutes();
  } else {
    dateTime.minute = t.getMinutes();
  }
  if (t.getSeconds() < 10) {
    dateTime.second = '0' + t.getSeconds();
  } else {
    dateTime.second = t.getSeconds();
  }
  return dateTime;
}

export const formatDate = (timeStamp: number) => {
  const dateTime: any = secondsToDateTime(timeStamp * 1000);
  return dateTime.date + ' ' + dateTime.monthText + ' ' + dateTime.year;
};

export const formatToLocaleTime = (timeStamp: number) => {
  if (!timeStamp) {
    return '';
  }
  const dateTime: any = new Date(timeStamp * 1000).toLocaleTimeString('hi-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  return dateTime;
};

export const formatTime = (timeStamp: number) => {
  if (!timeStamp) {
    return '';
  }
  const dateTime: any = secondsToDateTime(timeStamp * 1000);
  return dateTime.hour + ':' + dateTime.minute;
};

export const getDateFromTimeInSec = (timeStamp: number) => {
  if (!timeStamp) {
    return '';
  }
  return `${formatDate(timeStamp)}, ${formatToLocaleTime(timeStamp)}`;
};

export const getQueryObj = (queryStr: string) => (queryStr ? parse(queryStr) : {});

export const currencyMapper: any = {
  INR: '₹',
};

export const formatPrice = (price: number) => {
  let newPrice: any = Math.round((price + Number.EPSILON) * 100) / 100;
  if (newPrice !== Math.floor(newPrice)) {
    newPrice = newPrice.toFixed(2);
  }
  return newPrice;
};

export const parsePrice = (props: { price: number; currency?: string }) => {
  const { price, currency = 'INR' } = props;
  const symbol = currencyMapper[currency];
  if (!price && price !== 0) {
    return '---';
  }
  const newPrice = formatPrice(price);
  return price < 0 ? `-${symbol}${newPrice * -1}` : `${symbol}${newPrice}`;
};

const getDays = (month: number) => {
  if ([1, 3, 5, 7, 8, 10, 12].indexOf(month) > -1) {
    return 31;
  } else if ([4, 6, 9, 11].indexOf(month) > -1) {
    return 30;
  }
  return 28;
};

export const formatExpiry = (expiryDate?: string) => {
  if (!expiryDate) {
    return '';
  }
  const dateArray: any = expiryDate.split('/');
  const today = new Date();
  const ed = new Date();
  if (+dateArray[0] < 1 || +dateArray[0] > 12) {
    return '';
  }
  dateArray[1] = `20${dateArray[1]}`;
  ed.setFullYear(+dateArray[1], +dateArray[0] - 1, getDays(+dateArray[0]));
  if (ed < today) {
    return '';
  }
  return dateArray.join('');
};

export const getLocale = () => {
  return 'hi';
};

export const splitUnderscore = (str: string) => {
  var strList = str.split('_');
  var out = '';
  for (var i = 0; i < strList.length; i++) {
    out += strList[i][0].toUpperCase() + strList[i].slice(1).toLowerCase() + ' ';
  }
  return out;
};

export const mSecToTime = (milliSeconds: number, minreq: number, secreq: number) => {
  let sec = 0,
    min = 0;
  if (minreq) {
    min = 1;
  }
  if (secreq) {
    sec = 1;
  }
  let curdayMiliSecs,
    days,
    hours,
    minutes,
    seconds,
    timestamp: Array<any> = [],
    minInMiliSecs,
    secInMiliSecs;

  if (milliSeconds > 0) {
    days = Math.floor(milliSeconds / (24 * 60 * 60 * 1000));
    curdayMiliSecs = milliSeconds % (24 * 60 * 60 * 1000);
    hours = Math.floor(curdayMiliSecs / (60 * 60 * 1000));
    if (hours < 0) {
      hours = 0;
    }

    minInMiliSecs = curdayMiliSecs % (60 * 60 * 1000);
    minutes = Math.floor(minInMiliSecs / (60 * 1000));
    if (minutes < 0) {
      minutes = 0;
    }

    secInMiliSecs = minInMiliSecs % (60 * 1000);
    seconds = Math.floor(secInMiliSecs / 1000);
    if (seconds < 0) {
      seconds = 0;
    }
  } else {
    days = hours = minutes = seconds = 0;
  }
  if (days > 0) {
    var dy = ' day';
    if (days > 1) {
      dy += 's';
    }
    timestamp.push(days + dy);
  }
  if (hours > 0) {
    timestamp.push(hours + ' hrs');
  }
  if (minutes > 0 && !min) {
    timestamp.push(minutes + ' min');
  }
  if (seconds > 0 && !sec) {
    timestamp.push(seconds + ' sec');
  }
  return timestamp.join(' ');
};

export const getDateFromEpoch = (epoch: string | number) => {
  return moment(epoch).format('DD-MM-YYY HH:MM');
};

export const getObjectWithKeyInArray = (array: Array<any>, key: string, value: string) => {
  if (!array || array.length === 0) {
    return null;
  } else {
    const object = array.find((obj) => obj[key] + '' === value + '');
    return !!object ? object : null;
  }
};

export const getWhatsappLink = (message: string, number: string = '') => {
  let link = 'https://wa.me/';
  if (!!number) {
    link += number;
  }
  if (!!message) {
    link += '?text=' + encodeURIComponent(message);
  }
  return link;
};
export const calculatePerc = (base: any, num: any) => {
  return Math.ceil(((base - num) / base) * 100);
};

export const loadScript = async (fileUrl: string, async = true, type = 'text/javascript') => {
  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.type = type;
      script.async = async;
      script.src = fileUrl;

      script.addEventListener('load', (ev) => {
        resolve({ status: true });
      });

      script.addEventListener('error', (ev) => {
        reject({
          status: false,
          message: `Failed to load the script ＄{fileUrl}`,
        });
      });

      document.body.appendChild(script);
    } catch (error) {
      reject(error);
    }
  });
};

function removeCommasAndParse(input: string): number {
  const stringWithoutCommas = input.replace(/,/g, '');

  return parseFloat(stringWithoutCommas);
}
export const calculatePercentage = (amount: number | string, percentage: number) => {
  const value = (removeCommasAndParse(amount.toString()) * percentage) / 100;
  const decimalPart = value - Math.floor(value);
  if (decimalPart >= 0.5) {
    return Math.ceil(value);
  } else {
    return Math.floor(value);
  }
};

export const redirectionFunction = (type: string | null, validity: string | null) => {
  window.location.href =
    window.location.origin + `/app/caraxes/marketplace/subscription-status?screen=${type}&validity=${validity}`;
};

export const redirectionToSubscriptionPage = (source: string | null) => {
  window.location.href = window.location.origin + `/app/caraxes/marketplace/subscription-page?source=${source}`;
};

export const getWeLangString = (key: string, defaultValue: string) => {
  let returnString = '';
  const xAppPlatform = sessionStorage['x-app-platform:'];
  try {
    if (xAppPlatform === 'android') {
      if (operatorapp && typeof operatorapp !== 'undefined' && operatorapp !== null) {
        returnString = operatorapp.getWebStringViaWeLang(key);
      }
    }
  } catch (error) {
    returnString = defaultValue;
  }
  if (!returnString) {
    returnString = defaultValue;
  }

  return returnString;
};

export const getContactsFromApp = async (demandId: string) => {
  if (await flutterNativeCall('phonebookPickerClick', { demandId })) {
    return;
  }

  try {
    if (typeof operatorapp !== 'undefined' && operatorapp && operatorapp !== null) {
      operatorapp.phonebookPickerClick(demandId);
    } else {
      console.log('Not viewing in webview');
    }
  } catch (error) {
    Sentry.captureException('Unable to open phonebook in native : {}');
  }
};

export function checkNonWorkingHoursForDetention() {
  const instant = new Date();
  const localDateTime = new Date(instant).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
  const hour = new Date(localDateTime).getHours();
  return hour >= 20 || hour <= 7;
}
export const _formatString = (messageTemplate: string | null | undefined, value: string | number) => {
  if (!messageTemplate) return '';
  const replacedString = messageTemplate.replace('%s', value.toString());
  return replacedString;
};
